import firebase from 'firebase'
import BackendService from './BackendService'
import Project from '@/models/Project'

export default class ProductService extends BackendService {
  async fetchUserProjects(userId: string): Promise<any> {
    const arr: Array<Project> = []
    return await this.$db
      .collectionGroup('project_users')
      .where('userId', '==', userId)
      .get()
      .then(async (snap: any) => {
        const arr: any = []
        const promises: Promise<any>[] = [];
        snap.forEach(async (doc: any) => {
          promises.push(
            this.fetchProject(doc.data().projectId)
              .then((item: Project) => {
                arr.push(item);
              })
              .catch((error) => {
                console.log('error in fetchUserProjects->fetchProject', error)
              })
          );
        })
        await Promise.all(promises)
        return arr
      })
      .catch((error: any) => {
        console.error('Error in fetchUserProjects: ' + error)
        return null
      })
  }

  async fetchCompanyProjects(companyId: string) {
    console.log('fetchCompanyProjects', companyId)
    return await this.$db
      .collection('projects')
      .where('companyId', '==', companyId)
      .get()
      .then((snap: any) => {
        const arr: any = []
        snap.forEach((doc: any) => {
          const item = doc.data()
          item.id = doc.ref.id
          item.added = doc.data().added ? doc.data().added.toDate() : null
          item.updated = doc.data().updated ? doc.data().added.toDate() : null
          arr.push(item)
        })
        return arr;
      })
      .catch((error: any) => {
        console.error('Error in fetchProject: ' + error)
        return null
      })
  }

  async fetchProject(projectId: string) {
    return await this.$db
      .collection('projects')
      .doc(projectId)
      .get()
      .then((doc: any) => {
        const item = doc.data()
        item.id = doc.ref.id
        item.added = doc.data().added ? doc.data().added.toDate() : null
        item.updated = doc.data().updated ? doc.data().added.toDate() : null
        return item
      })
      .catch((error: any) => {
        console.error('Error in fetchProject: ' + error)
        return null
      })
  }

  async fetchProjectData(projectId: string) {
    const arr: Array<Project> = []
    return await this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_data')
      .get()
      .then((snap: any) => {
        snap.forEach((doc: any) => {
          const item = doc.data()
          item.type = doc.ref.id
          arr.push(item)
        })
        return arr
      })
      .catch((error: any) => {
        console.error('Error in fetchProjectData: ' + error)
        return null
      })
  }

  async createProject(item: any) {
    const dt = new Date()
    item.added = dt
    item.updated = dt
    return await this.$db
      .collection('projects')
      .add(item)
      .then(async (docRef: any) => {
        return docRef.id
      })
      .catch((error: any) => {
        console.error('Error in createProject', error)
      })
  }

  async editProject(item: Project) {
    item.added = new Date(item.added)
    item.updated = new Date()
    return await this.$db
      .collection('projects')
      .doc(item.id)
      .update(item)
      .then((result: any) => {
        return result
      })
      .catch((error: any) => {
        console.error('Error in editProduct', error)
      })
  }

  async addProjectUserByCompanyId(companyId: string, userId: string, userInfo: any) {
    return await this.$db
      .collection('projects')
      .where('companyId', '==', companyId)
      .get()
      .then(async (snap: any) => {
        const promises: Promise<any>[] = [];
        snap.forEach((doc: any) => {
          promises.push(
            this.addProjectUser(doc.ref.id, userId, userInfo.firstName, userInfo.lastName, userInfo.email, 'ACTIVE', false)
          )
        })
        return await Promise.all(promises)
      })
      .catch((error: any) => {
        console.error('Error in addProjectUserByCompanyId: ' + error)
        return null
      })
  }

  async addUserToDefaultProject(companyId: string, userId: string, firstName: string, lastName: string, email: string, status: string, admin: boolean) {
    await this.$db
      .collection('projects')
      .where('companyId', '==', companyId)
      .where('default', '==', true)
      .get()
      .then(async (snap: any) => {
        const promises: Promise<any>[] = [];
        snap.forEach((doc: any) => {
          promises.push(
            this.addProjectUser(doc.ref.id, userId, firstName, lastName, email, status, admin)
          )
        })
        return await Promise.all(promises)
      })
      .catch((error: any) => {
        console.error('Error in addUserToDefaultProject', error)
      })
  }

  async addProjectUser(projectId: string, userId: string, firstName: string, lastName: string, email: string, status: string, admin: boolean) {

    const batch = this.$db.batch()

    // Set the company_user
    const relRef = this.$db.collection('projects').doc(projectId).collection('project_users').doc(userId)
    const docRef = this.$db.collection('projects').doc(projectId)

    // update
    batch.set(relRef, {
      userId,
      projectId,
      firstName,
      lastName,
      email,
      status,
      admin,
      added: new Date(),
    })
    batch.update(docRef, { users: firebase.firestore.FieldValue.arrayUnion(userId), invites: firebase.firestore.FieldValue.arrayRemove(email) });

    // Commit the batch
    batch.commit()
      .then(() => {
        return true;
      })
      .catch((error: any) => {
        console.error('Error in BATCH for addProjectUser', error)
        return false;
      })
  }

  /*
  async addProjectUser (projectId: string, userId: string, firstName: string, lastName: string, email: string, status: string, admin: boolean) {
    await this.$db
      .collection('projects')
      .doc(projectId)
      .collection('project_users')
      .doc(userId)
      .set({
        userId,
        projectId,
        firstName,
        lastName,
        email,
        status,
        admin,
        added: new Date(),
      })
      .catch((error: any) => {
        console.error('Error in addProjectUser', error)
      })
  }
  */

}
